<template>
    <div class="main-layout">
        <navbar/>
        <div class="mt-4">
            <child/>
        </div>
    </div>
</template>

<script>
    import Navbar from '~/components/Navbar'

    export default {
        name: 'BasicLayout',

        components: {
            Navbar,
        },
    }


</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/layouts/login.vue